package com.nonopn.skywatcher.common.app.pages.map.view

import androidx.compose.foundation.Image
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.home.LocalIsPreview
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.weather.ProbeStatus
import com.nonopn.skywatcher.common.app.pages.map.model.weather.WeatherReport
import com.nonopn.skywatcher.common.app.pages.map.view.map.MapOverlay
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.google_logo_dark
import com.nonopn.skywatcher.common.app.res.preview
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal
import org.jetbrains.compose.resources.painterResource
import ovh.plrapps.mapcompose.ui.MapUI


@Composable
fun Map(
    modifier: Modifier,
    model: MainScreenModel
) {
    if (LocalIsPreview.current) {
        Column(
            modifier = modifier,
        ) {
            Image(
                painter = painterResource(Res.drawable.preview),
                contentDescription = ""
            )
        }
        return
    }

    model.configureMapState()

    val scope = rememberCoroutineScope()

    val state by model.states.collectAsState()

    Box(modifier) {
        if (!state.initialized) {
            return@Box
        }

        MapUI(
            modifier = Modifier.fillMaxSize(),
            state = model.mapState
        )

        MapOverlay(
            modifier = Modifier.fillMaxSize(),
            model
        )

        Row(
            modifier = Modifier.align(Alignment.BottomStart).padding(12.dp),
            verticalAlignment = Alignment.Bottom
        ) {
            Image(
                modifier = Modifier.height(15.dp),
                painter = painterResource(Res.drawable.google_logo_dark),
                contentDescription = ""
            )
        }

        Row(
            modifier = Modifier.align(Alignment.BottomEnd).padding(12.dp),
            verticalAlignment = Alignment.Bottom
        ) {
            TextNormal(
                text = LocalApp.current.appTitle.localized()
            )
            /*Image(
                modifier = Modifier.height(25.dp),
                painter = painterResource(Res.drawable.vaisala_xweather_logo_dark),
                contentDescription = ""
            )*/
        }
    }
}

@HotPreview(widthDp = 400, heightDp = 150, darkMode = true)
@HotPreview(widthDp = 400, heightDp = 150, darkMode = false)
@Composable
private fun MapPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme(), isPreview = true) {
        Map(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false,
                fakeProbeStatus = ProbeStatus(
                    report = WeatherReport.fake()
                ),
            )
        )
    }
}
